import React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";

const WdsfTeam = ({ team, t }) => (
    <Box>
        <List dense>
            <ListItem>
                <ListItemText primary={`${team.name}`} secondary={t("reg.team_name")} />
            </ListItem>
            <ListItem>
                <ListItemText primary={`${team.members.length}`} secondary={t("reg.team_size")} />
            </ListItem>
            <ListItem>
                <ListItemText primary={`${team.country}`} secondary={t("reg.country")} />
            </ListItem>
        </List>
    </Box>
);

export default WdsfTeam;
